import React from 'react';
import { Game } from './type';

const getNumber = (value: any, defaultNumber = 0): number => {
  let result = Number(value);
  result = Number.isNaN(result) ? defaultNumber : result;
  return result;
};

export const sortGames = (games: Game[]): Game[] => {
  if (!Array.isArray(games)) return [];
  return games.sort((a, b) => {
    let aMatchScore = getNumber(a?.matchScore, -1);
    let bMatchScore = getNumber(b?.matchScore, -1);
    return -(aMatchScore - bMatchScore);
  });
};

export const getGameBySimilarGame = (game: any): Game => {
  const _game: Game = {
    id: '',
    entityType: 'all',
    entityName: '',
    cover: '',
    publisher: '',
    releaseTime: '',
    matchScore: 0,
  };

  if (!game) {
    console.warn('an error occured in getGame: parameter game is null');
    return _game;
  }

  _game.id = game.app_id || '';
  _game.entityType = game.entity_type || 'all';
  _game.entityName = game.name || '';
  _game.cover = game.cover || '';
  _game.publisher = game.publisher || '';
  _game.releaseTime = game.time || '';
  _game.matchScore = 0;

  return _game;
};

export const getGame = (game: any): Game => {
  const _game: Game = {
    id: '',
    entityType: 'all',
    entityName: '',
    cover: '',
    publisher: '',
    releaseTime: '',
    matchScore: 0,
  };

  if (!game) {
    console.warn('an error occured in getGame: parameter game is null');
    return _game;
  }

  _game.id = game.game_id || '';
  _game.entityType = game.entity_type || 'all';
  _game.entityName = game.entity_name || '';
  _game.cover = game.cover || '';
  _game.publisher = game.publisher || '';
  _game.releaseTime = game.release_time || '';
  _game.matchScore = game.match_score || 0;

  return _game;
};


type GetTextWithHighlightOption = {
  // 是否拆分成单个字符 判断是否需要高亮
  isSeparate?: boolean;
  // 是否忽略大小写 判断是否高亮
  isIgnoreCase?: boolean;
};

/**
 * 获取指定文本，指定关键字 高亮处理指定文本后的 ReactNode[]
 * @param text 指定文本
 * @param keyword 关键字
 * @param options 配置项，参考GetTextWithHighlightOption的注释，默认 拆分、忽略大小写
 * @returns 返回高亮处理后的ReactNode[]
 */
export const getTextWithHighlight = (text: string, keyword: string, options?: GetTextWithHighlightOption) => {
  if (typeof text !== 'string' || typeof keyword !== 'string') return text;

  const { isSeparate = true, isIgnoreCase = true } = options || {};
  const _keyword = isIgnoreCase ? keyword.toLowerCase() : keyword;

  if (!isSeparate) {
    // TODO: 处理 关键字高亮匹配不拆分的场景
    return text;
  }

  return text.split('').map((char, index) => {
    const _char = isIgnoreCase ? char.toLowerCase() : char;
    const isHighlight = _keyword.includes(_char);

    if (!isHighlight) return char;

    return React.createElement(
      'span',
      {
        key: index,
        className: 'is-highlight'
      },
      React.createElement('b', {}, [char])
    );
  });
};
